import { render, staticRenderFns } from "./publish-field-year.vue?vue&type=template&id=3161d229&"
import script from "./publish-field-year.vue?vue&type=script&lang=js&"
export * from "./publish-field-year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports